var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.287,
    height: 16.554,
    viewBox: "0 0 16.287 16.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-google",
    "data-name": "Icon awesome-google",
    d: "M16.287,9.033a7.686,7.686,0,0,1-8.01,8.083,8.277,8.277,0,1,1,0-16.554,7.96,7.96,0,0,1,5.55,2.166L11.575,4.895C8.627,2.051,3.147,4.187,3.147,8.84a5.185,5.185,0,0,0,5.13,5.227,4.476,4.476,0,0,0,4.7-3.568h-4.7V7.651h7.88A7.256,7.256,0,0,1,16.287,9.033Z",
    transform: "translate(0 -0.563)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/Icon-Google.18757eaae341d5b3457f5a1f249f1654.svg";
export { ForwardRef as ReactComponent };